import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions'; import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteTagMaster = () => {
    const authorizedAxiosIntitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const [tagName, setTagName] = useState('')
    const [tagDescription, setTagDescription] = useState('')
    const [courses, setCourses] = useState([])
    const [editId, setEditId] = useState(null)
    const [error, setError] = useState('')
    const [errord, setErrord] = useState('')

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [tagSort, setTagSort] = useState(null);
    const [descriptionSort, setDescriptionSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["tagName", "tagDescription", "createdAt"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getTags();
    }, []);

    const getTags = async () => {
        const apiUrl = `/get-institute-tag-master?instituteMasterId=${instituteMasterId}`;
        try {
            const response = await authorizedAxiosIntitute.get(apiUrl);
            setCourses(response.data.result);
        } catch (error) {
            setCourses([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTags();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCourses(await searchArray("I", `/get-institute-tag-master?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(courses, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(courses.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > courses.length) {
            endIndex = courses.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(courses.slice(startIndex, endIndex));
    }, [courses, currPage, itemsPerPage]);

    useEffect(() => {
        if (tagName !== '') {
            setError('')
        }
        if (tagDescription !== '') {
            setErrord('')
        }
    }, [tagName, tagDescription])

    const addCourse = async () => {
        const apiUrl = `/add-institute-tag-master`;
        if (tagName !== '' && tagDescription !== '') {
            try {
                setLoading(true);
                const response = await authorizedAxiosIntitute.post(apiUrl, {
                    instituteMasterId,
                    tagName,
                    tagDescription
                });

                await getTags();
                setSaveId(response.data.result.id);
                setTagName('')
                setTagDescription('')

                setTagSort(null);
                setDescriptionSort(null);
                setDateSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            if (tagName == '') {
                setError("This field is required.")
            }
            if (tagDescription == '') {
                setErrord("This field is required.")
            }
        }
    }

    const deleteCourse = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-tag-master?id=${id}`;
                const response = await authorizedAxiosIntitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, courses.length);
                await getTags();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateCourse = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-tag-master?id=${editId}`;
            const response = await authorizedAxiosIntitute.put(apiUrl, { instituteMasterId, tagName, tagDescription });
            await getTags();
            setEditId(null);
            setTagName('')
            setTagDescription('')
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (tagSort == true || tagSort == false) {
            setDescriptionSort(null);
            setDateSort(null);
        }
    }, [tagSort])

    useEffect(() => {
        if (descriptionSort == true || descriptionSort == false) {
            setTagSort(null);
            setDateSort(null);
        }
    }, [descriptionSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setTagSort(null);
            setDescriptionSort(null);
        }
    }, [dateSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Tag Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-tag"></i> Tag Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12 board_name mt-3 mb-3">

                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Tag Name</label>
                                                    <input type="text" className="form-control" id="gradeName" value={tagName} onChange={(e) => setTagName(e.target.value.toUpperCase())} />

                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>


                                                <div className="col-md-12 board_name">

                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Tag Description Name</label>
                                                    <input type="text" className="form-control" id="gradeName2" name='2' value={tagDescription} onChange={(e) => setTagDescription(e.target.value.toUpperCase())} />

                                                    {errord && <p style={{ color: 'red' }}>{errord}</p>}


                                                </div>

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto new_button">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: '20px' }} type="button" onClick={addCourse}>Save</button>
                                                        }                                                        <button className="btn btn-danger delete_icon delete_icon " type="button" style={{ marginRight: "20px" }} onClick={() => { setTagName(''); setTagDescription(''); setEditId('') }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateCourse} disabled={!editId}>Update</button>)
                                                        }
                                                        {/* <button className="btn btn-outline-secondary" type="button">Close</button> */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagSort} setSortState={setTagSort} setData={setCourses} setCurrPage={setCurrPage} sortingPath={"tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Tag Description
                                                                            <SortIcon sortState={descriptionSort} setSortState={setDescriptionSort} setData={setCourses} setCurrPage={setCurrPage} sortingPath={"tagDescription"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setCourses} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((course, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{course.tagName}</td>
                                                                                        <td>{course.tagDescription}</td>
                                                                                        <td>{course.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTagName(course.tagName);
                                                                                                setTagDescription(course.tagDescription);
                                                                                                setEditId(course.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === course.id} onClick={() => deleteCourse(course.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Tag Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={courses.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteTagMaster;